import React, { useEffect, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import validCellphonePY from '../../../shared/utils/validCellPhonePY'
import AuthService from '../../../shared/services/auth-service'
import { gameId } from '../../../constants/activity-constants'
import Button from '../../atoms/button/button'
import DataPolicy from '../../../shared-campaign/components/atoms/data-policy/data-policy'
import UseChecksPolicy from '../../../shared-campaign/components/hooks/useChecksPolicy'
import useDataPolicy from '../../../shared-campaign/components/hooks/useDataPolicy'
import { siteUrl } from '../../../shared/utils/siteUrl'
import DataPolicyService from '../../../shared-campaign/services/dataPolicy'
import { pushEventData } from '../../../utils/pushEventDataLayer'

import './modalUpdateData.scss'
import ButtonClose from '../../atoms/button-close/button-close'
import Show from '../../../utils/show'

const LOCALE = process.env.LOCALE;
const italatam = LOCALE === 'es-AR';

const ModalUpdateData = props => {
  // props.success
  const { checksPolicy } = useDataPolicy()

  const {
    checks,
    changeCheck,
    isAllChecksTrue,
    getPayloadCheck,
  } = UseChecksPolicy(true)
  const homeLink = siteUrl + '/'

  const resultQuery = useStaticQuery(
    graphql`
      query USER_DATA_QUERY {
        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            node_locale
            codigoIcu
            titulo
            tieneMisPuntos
            departamentos {
              codigo
              nombre
            }
            ciudades {
              codigo
              codigoDepartamento
              nombre
            }
          }
        }
      }
    `
  )

  const [step, setStep] = useState(1)

  var ciudades = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].ciudades
  var departamentos = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
  )[0].departamentos

  var userInfo = JSON.parse(localStorage.getItem('USER_INFO'))

  const getNoPrefix = num => {
    return num.slice(
      process.env.COUNTRY_PHONE_PREFIX.length,
      userInfo.cellPhone.length
    )
  }

  //Input values
  const [departamentoSelected, setDepartamentoSelected] = useState(
    userInfo.location ? userInfo.location.countryState.toString() : ''
  )
  const [ciudadSelected, setCiudadSelected] = useState(
    userInfo.location ? userInfo.location.city.toString() : ''
  )
  const [nameCity, setNameCity] = useState('')
  const [nameDep, setNameDep] = useState('')

  useEffect(() => {
    const city =
      ciudadSelected && ciudades.filter(item => item.codigo === ciudadSelected)

    const dep =
      departamentoSelected &&
      departamentos.filter(item => item.codigo === departamentoSelected)


    if (dep.length === 0) {
      setDepartamentoSelected('')
      return
    }
    if (city.length === 0) {
      setCiudadSelected('')
      return
    }

    setNameDep(dep[0]?.nombre)
    setNameCity(city[0]?.nombre)
  }, [ciudadSelected, departamentoSelected])

  const [nameValue, setNameValue] = useState(userInfo.name)
  const [lastnameValue, setLastnameValue] = useState(userInfo.lastName)
  const [errorMessage, setErrorMessage] = useState('')
  const [phoneValue, setPhoneValue] = useState(
    userInfo.cellPhone !== null
      ? validCellphonePY(getNoPrefix(userInfo.cellPhone))
      : null
  )
  const [addressValue, setAddressValue] = useState(
    userInfo.location ? userInfo.location.address : ''
  )

  const [addressDetailValue, setaddressDetailValue] = useState(
    userInfo.location ? userInfo.location.addressDetail : ''
  )

  const [zipCodeValue, setZipCodeValue] = useState('')

  const handleChangeChecks = (e, index) => {
    changeCheck(index, e.target.checked)
  }

  useEffect(() => {
    if (process.env.LOCALE === 'es-PR') {
      const indexOF = addressDetailValue.indexOf('ZIP')
      if (indexOF !== -1) {
        //Extraer detalle direccion
        let detailAdrres = addressDetailValue.slice(0, indexOF - 1)
        let zip = addressDetailValue.slice(indexOF + 5, indexOF + 10)
        setaddressDetailValue(detailAdrres)
        setZipCodeValue(zip)
      } else {
        setZipCodeValue('')
      }
    } else {
      setZipCodeValue('00000')
    }
  }, [])

  /* ----- Error flags ----- */
  const [nameError, setNameError] = useState(false)
  const [lastnameError, setLastnameError] = useState(false)
  const [phoneError, setPhoneError] = useState(false)
  const [addressError, setAddressError] = useState(false)
  const [departamentoSelectedError, setDepartamentoSelectedError] = useState(
    false
  )
  const [ciudadSelectedError, setCiudadSelectedError] = useState(false)
  const [phoneFormatError, setPhoneFormatError] = useState(false)
  const [updateError, setUpdateError] = useState(false)
  const [zipError, setZipError] = useState(false)
  const [zipFormatError, setZipFormatError] = useState(false)
  const [tycError, settycError] = useState(false)

  /* ----- Error flags ----- */

  const [disableButton, setdisableButton] = useState(false)

  const errorLabel = (
    <label className="f-input-label-error">*Campo requerido</label>
  )
  const addEventData = (props) => {
    pushEventData(Object.assign({
      event: 'Actualización datos',
      action: "click actualizar",
    }, props));
  }
  const handleSubmit = e => {
    e.preventDefault()

    if (!haveErrors()) {

      addEventData({
        label: 'Actualizar',
        department: nameDep,// process.env.LOCALE === 'es-PR' ? 'No aplica' :
        city: nameCity
      });


      setStep(2)

    }
  }

  const nextToOTP = inputValueOTPAux => {
    let addressDetail =
      process.env.LOCALE !== 'es-PR'
        ? addressDetailValue
        : addressDetailValue + ' ZIP: ' + zipCodeValue

    let payload = {
      adult: userInfo.adult,
      cellPhone:
        phoneValue === '' ||
          phoneValue === ' ' ||
          phoneValue === null ||
          phoneValue === undefined
          ? null
          : process.env.COUNTRY_PHONE_PREFIX +
          (process.env.LOCALE === 'es-PY'
            ? parseInt(phoneValue, 10).toString()
            : parseInt(phoneValue).toString()),
      codeDestination: userInfo.codeDestination,
      country: userInfo.country,
      location: {
        city: ciudadSelected,
        address: addressValue,
        addressDetail: addressDetail,
      },
      email: userInfo.email,
      lastName: lastnameValue,
      name: nameValue,
      profilePicture: userInfo.profilePicture,
      otp: inputValueOTPAux,
    }

    let tokenId = JSON.parse(localStorage.getItem('TOKEN_INFO')).idToken

    let config = {
      headers: {
        Authorization: tokenId,
      },
    }
    setdisableButton(true)
    AuthService.updateAccount(payload, config)
      .then(res => {
        if (res.status === 200) {
          addEventData({ label: 'Enviar' });
          // pushEventDataLayer(
          //   'Interacciones - Código verificación',
          //   'busca-palabras',
          //   'click validacion',
          //   'enviar'
          // )
          setdisableButton(false)
          // setInfoUser(res.data)
          localStorage.setItem('USER_INFO', JSON.stringify(res.data))

          let copyUpdateData = localStorage.getItem('UPDATE_DATA_ACTIVITY')
          copyUpdateData = copyUpdateData ? JSON.parse(copyUpdateData) : []
          copyUpdateData.push({
            email: res.data.email,
            activityId: gameId,
          })
          localStorage.setItem(
            'UPDATE_DATA_ACTIVITY',
            JSON.stringify(copyUpdateData)
          )

          DataPolicyService.updatePolicy(getPayloadCheck(), config).then(
            res => {
              console.log('update policy, data updated')
            }
          )

          props.success()
        } else {
          setErrorMessage(res.userMessage)
          setUpdateError(true)
          setdisableButton(false)
        }
      })
      .catch(e => console.log(e))
  }

  const mistakeCellByCountry = num => {
    return (
      num.toString().length < parseInt(process.env.MIN_DIGITS) ||
      num.toString().length > parseInt(process.env.MAX_DIGITS)
    )
  }

  const haveErrors = () => {
    if (isAllChecksTrue()) {
      settycError(true)
    } else {
      settycError(false)
    }

    if (nameValue === '' || nameValue === ' ') {
      setNameError(true)
    } else {
      setNameError(false)
    }

    if (lastnameValue === '' || lastnameValue === ' ') {
      setLastnameError(true)
    } else {
      setLastnameError(false)
    }

    if (
      phoneValue !== '' &&
      phoneValue !== ' ' &&
      phoneValue !== null &&
      phoneValue !== undefined
    ) {
      if (mistakeCellByCountry(phoneValue)) {
        setPhoneFormatError(true)
        return true
      } else {
        setPhoneFormatError(false)
      }
    }

    if (phoneValue === '' || phoneValue === ' ' || phoneValue === null) {
      setPhoneError(true)
    } else {
      setPhoneError(false)
    }

    if (addressValue === ' ' || addressValue === '') {
      setAddressError(true)
    } else {
      setAddressError(false)
    }

    if (departamentoSelected === ' ' || departamentoSelected === '') {
      setDepartamentoSelectedError(true)
    } else {
      setDepartamentoSelectedError(false)
    }

    if (ciudadSelected === ' ' || ciudadSelected === '') {
      setCiudadSelectedError(true)
    } else {
      setCiudadSelectedError(false)
    }

    if (
      [null, undefined].includes(zipCodeValue) ||
      zipCodeValue.trim() === ''
    ) {
      setZipFormatError(true)
      return true
    } else {
      setZipFormatError(false)
    }

    if (zipCodeValue === '' || nameValue === ' ') {
      setZipError(true)
    } else {
      setZipError(false)
    }

    return (
      isAllChecksTrue() ||
      nameValue === '' ||
      nameValue === ' ' ||
      lastnameValue === '' ||
      lastnameValue === ' ' ||
      phoneValue === '' ||
      phoneValue === ' ' ||
      phoneValue === null ||
      addressValue === '' ||
      addressValue === ' ' ||
      departamentoSelected === '' ||
      departamentoSelected === ' ' ||
      ciudadSelected === '' ||
      ciudadSelected === ' ' ||
      zipCodeValue === '' ||
      nameValue === ' ' ||
      zipCodeValue === null
    )
  }

  const cityLabel =
    process.env.LOCALE === 'es-PR'
      ? 'Municipio'
      : process.env.LOCALE === 'es-PE'
        ? 'Distrito'
        : 'Ciudad'

  const singleLabel =
    process.env.LOCALE === 'es-EC' ||
      process.env.LOCALE === 'es-AR' ||
      process.env.LOCALE === 'es-DO' ||
      process.env.LOCALE === 'es-UY'
      ? 'Provincia'
      : process.env.LOCALE === 'es-CL'
        ? 'Región'
        : 'Departamento'

  const houseCopie =
    process.env.LOCALE === 'es-PE'
      ? 'Urbanización / N° Departamento / Referencia'
      : process.env.LOCALE === 'es-DO'
        ? 'Sector / edificio / apartamento'
        : 'Barrio / edificio / apartamento'

  // step otp

  const token = JSON.parse(localStorage.getItem('TOKEN_INFO')).idToken

  const config = {
    headers: {
      Authorization: token,
    },
  }
  const [inputValueOTP, setInputValueOTP] = useState('')

  const [disableButtonOTP, setdisableButtonOTP] = useState(false)
  const [codeDestination, setcodeDestination] = useState('EMAIL')
  const [response, setResponse] = useState('waiting')
  const [noCellphoneError, setnoCellphoneError] = useState(null)

  const [resentCode, setresentCode] = useState(false)
  const [disableResend, setdisableResend] = useState(false)

  const [nextButtonDisable, setnextButtonDisable] = useState(true)

  const sendCode = reSend => {
    setdisableButtonOTP(true)

    if (reSend) {
      setresentCode(true)
      setdisableResend(true)
      setTimeout(() => {
        setresentCode(false)
        setdisableResend(false)
      }, 10000)
    }


    AuthService.sendOTP(codeDestination, config)
      .then(res => {
        if (res.status === 200) {
          // try {
          //   // trackEvent
          //   window.dataLayer = window.dataLayer || []
          //   window.dataLayer.push({
          //     event: 'Interacciones - Medio validación',
          //     eventCategory: 'busca-palabras',
          //     eventAction: 'click validacion',
          //     eventLabel: 'enviar ',
          //     MedioValidacion: codeDestination,
          //   })
          // } catch (e) {
          //   console.log('Datalayer Error')
          // }

          setdisableButtonOTP(false)
          setStep(3)
        } else if (res.status === 400) {
          setdisableButtonOTP(false)
          setnoCellphoneError(res.userMessage)
        } else {
          console.log(res)
        }
      })
      .catch(e => console.log(e))
  }

  const handleInputValidation = e => {
    setInputValueOTP(e.target.value)

    var value = e.target.value

    if (e.target.value.length === 6) {
      AuthService.validateOTP(value, config)
        .then(res => {
          if (res.data.valid) {
            setResponse('success')
            setnextButtonDisable(false)
          } else {
            setResponse('error')
          }
        })
        .catch(e => console.log(e))
    } else {
      setResponse('waiting')
    }
  }

  return (
    // <div>
    //   acttulizar data
    //   <button onClick={props.success}>exito</button>
    // </div>
    <div className="f-modal-update-data">
      <ButtonClose onClick={props.close} />
      <div className="f-modal-update-data__wrapper">
        <div className={"f-modal-update-data__content  --step" + step}>
          {step === 1 && (
            <>
              <div className="f-modal-update-data__description">
                <p className='title'>
                  {process.env.LOCALE === 'es-AR' ? 'Actualizá' : 'Actualiza'}{' '}
                  tus datos
                </p>
                <p className='description'>
                  <Show valid={process.env.LOCALE !== 'es-BO'}>
                    Y si {italatam ? 'sos' : 'eres'} una ganadora, podrás recibir tu premio en casa sin
                    problemas.
                  </Show>
                  <Show valid={process.env.LOCALE === 'es-BO'}>
                    Recuerda que debes actualizar tus datos personales para continuar
                  </Show>
                </p>
              </div>
              <div className={`form-update-data`}>
                <form onSubmit={handleSubmit}>
                  <div className={`form-group`}>
                    <div className={`input-group`}>
                      <label className="">Nombre:</label>
                      <input
                        className="border-color-input"
                        type="text"
                        value={nameValue || ""}
                        onChange={e =>
                          setNameValue(e.target.value.replace(/ {2}/g, ' '))
                        }
                      />
                      {nameError && errorLabel}
                    </div>
                    <div className={`input-group`}>
                      <label className="">Apellido:</label>
                      <input
                        className="border-color-input"
                        type="text"
                        value={lastnameValue || ""}
                        onChange={e =>
                          setLastnameValue(e.target.value.replace(/ {2}/g, ' '))
                        }
                      />
                      {lastnameError && errorLabel}
                    </div>
                  </div>

                  <div className={`form-group`}>
                    {process.env.LOCALE !== 'es-PR' && (
                      <div className={`input-group`}>
                        <label className="">{singleLabel}:</label>
                        <select
                          className="border-color-input"
                          value={departamentoSelected}
                          onChange={e =>
                            setDepartamentoSelected(e.target.value)
                          }
                        >
                          <option value="">Selecciona</option>
                          {departamentos.map((departamento, index) => {
                            return (
                              <option value={departamento.codigo} key={index}>
                                {departamento.nombre}
                              </option>
                            )
                          })}
                        </select>
                        {departamentoSelectedError && errorLabel}
                      </div>
                    )}

                    {process.env.LOCALE === 'es-PR' ? (
                      <div className={`input-group`}>
                        <label className="">{cityLabel}:</label>
                        <select
                          className="border-color-input"
                          value={ciudadSelected}
                          onChange={e => setCiudadSelected(e.target.value)}
                        >
                          {ciudades.map((ciudad, index) => {
                            return (
                              <option value={ciudad.codigo} key={index}>
                                {ciudad.nombre}
                              </option>
                            )
                          })}
                        </select>
                        {ciudadSelectedError && errorLabel}
                      </div>
                    ) : (
                      departamentoSelected !== '' && (
                        <div className={`input-group`}>
                          <label className="">{cityLabel}:</label>
                          <select
                            className="border-color-input"
                            value={ciudadSelected}
                            onChange={e => setCiudadSelected(e.target.value)}
                          >
                            <option value="">Selecciona</option>
                            {ciudades
                              .filter(
                                ciu =>
                                  ciu.codigoDepartamento ===
                                  departamentoSelected
                              )
                              .map((ciudad, index) => {
                                return (
                                  <option value={ciudad.codigo} key={index}>
                                    {ciudad.nombre}
                                  </option>
                                )
                              })}
                          </select>
                          {ciudadSelectedError && errorLabel}
                        </div>
                      )
                    )}
                  </div>

                  <div className={`form-group`}>
                    <div className={`input-group`}>
                      <label className="">Dirección:</label>
                      <input
                        className="border-color-input"
                        type="numeric"
                        value={addressValue || ""}
                        maxLength="100"
                        onChange={e => {
                          setAddressValue(
                            e.target.value
                              .replace(
                                /[^a-zA-ZáéíóúÁÉÍÓÚ,.0-9#°;:()¿?¡!_\- ]/g,
                                ''
                              )
                              .replace(/ {2}/g, ' ')
                              .slice(0, 100)
                          )
                        }}
                      />
                      {addressError && errorLabel}
                    </div>

                    <div className={`input-group`}>
                      <label className="">
                        Datos adicionales de tu ubicación:
                      </label>
                      <input
                        className="border-color-input"
                        placeholder={houseCopie}
                        maxLength="60"
                        type="numeric"
                        value={addressDetailValue || ""}
                        onChange={e => {
                          setaddressDetailValue(
                            e.target.value
                              .replace(
                                /[^a-zA-ZáéíóúÁÉÍÓÚ,.0-9#°;:()¿?¡!_\- ]/g,
                                ''
                              )
                              .replace(/ {2}/g, ' ')
                              .slice(0, 60)
                          )
                        }}
                      />
                    </div>
                  </div>

                  <div className={`form-group`}>
                    {process.env.LOCALE === 'es-PR' && (
                      <div className={`input-group`}>
                        <label className=""> ZIP Code:</label>
                        <input
                          className="border-color-input"
                          type="text"
                          value={zipCodeValue || ""}
                          onChange={e => setZipCodeValue(e.target.value)}
                        />
                        {zipError && errorLabel}
                        {zipFormatError && (
                          <label className="f-input-label-error">
                            *ZIP Code inválido
                          </label>
                        )}
                      </div>
                    )}

                    <div className={`input-group`}>
                      <label className="">Celular:</label>
                      <input
                        className="border-color-input"
                        type="numeric"
                        value={phoneValue || ""}
                        onChange={e =>
                          setPhoneValue(
                            e.target.value
                              .replace(/\D/, '')
                              .slice(0, parseInt(process.env.MAX_DIGITS))
                          )
                        }
                      />
                      {phoneError && errorLabel}
                      {phoneFormatError && (
                        <label className="f-input-label-error">
                          *Número inválido
                        </label>
                      )}
                    </div>
                  </div>
                  {updateError && (
                    <p className="">
                      Tus datos no se pudieron actualizar.{' '}
                      {errorMessage && errorMessage}
                    </p>
                  )}

                  <div className="habeas-data__win-product">
                    <div className="habeas-data__win-product">
                      <div className="f-step-question-checkBox-group">
                        {checksPolicy.map((item, index) => {
                          // si es distinto a mis puntos
                          return (
                            <div
                              className="f-step-question-form-checkBox"
                              key={item.idPrincipal}>
                              <input
                                onChange={e => {
                                  handleChangeChecks(e, index)
                                }}
                                type="checkbox"
                                name="terms"
                                value="Bike"
                                checked={checks[index] || false}
                              />
                              <p className="f-step-question-form-checkBox-copy">
                                <a
                                  className="f-step-question-form-link"
                                  rel="noopener noreferrer"
                                  target="_blank"
                                  href={homeLink + item.redireccion}
                                >
                                  {item.tituloPrincipal}
                                </a>
                              </p>
                              <span className="f-checkmark"></span>
                            </div>
                          )
                        })}

                        {tycError && (
                          <label className="f-label-error">
                            *Debes aceptar para continuar
                          </label>
                        )}
                      </div>
                      <DataPolicy />
                    </div>
                  </div>
                  <div className={`button-submit`}>
                    <Button
                      title="ACTUALIZAR"
                      size="f-large"
                      color="f-blue"
                      type="submit">ACTUALIZAR</Button>

                  </div>
                </form>
              </div>
            </>
          )}

          {step === 2 && (
            <>
              <div className="f-modal-update-data__description">
                <p className='title'>Necesitamos verificar que {italatam ? 'sos vos' : 'eres tú'} </p>

                <p className='description'>
                  <Show valid={!italatam}> Necesitamos verificar que eres tú  , te enviaremos un código
                    único para que lo ingreses a continuación. Elige el medio por
                    el cuál quieres realizar esta validación.</Show>
                  <Show valid={italatam}>
                    Para comprobar tu identidad te enviaremos un código único para que lo ingresés a continuación. Elige el medio por el cual querés realizar esta validación
                  </Show>

                </p>
              </div>

              <div className="f-radio-container ">
                <div className="f-radio-option">
                  Celular (SMS)
                  <input
                    type="radio"
                    name="codeDestination"
                    onChange={e => {
                      setcodeDestination(e.target.value)
                      setnoCellphoneError(null)
                    }}
                    checked={codeDestination === 'SMS'}
                    defaultValue="SMS"
                  />
                  <span className="checkmark"></span>
                </div>
                <div className="f-radio-option">
                  Correo
                  <input
                    type="radio"
                    name="codeDestination"
                    onChange={e => {
                      setcodeDestination(e.target.value)
                      setnoCellphoneError(null)
                    }}
                    checked={codeDestination === 'EMAIL'}
                    defaultValue="EMAIL"
                  />
                  <span className="checkmark"></span>
                </div>
              </div>
              <span className="f-input-label-error">{noCellphoneError}</span>
              <div className="f-modal-update-data__buttons">
                <Button
                  title="VOLVER"
                  size="f-large"
                  color="f-blue"
                  onClick={() => {
                    addEventData({
                      label: 'Volver',
                    });
                    setStep(1)
                  }}>VOLVER</Button>

                <Button
                  className='--pink'
                  title="ENVIAR"
                  size="f-large"
                  color="f-blue"
                  loading={disableButtonOTP}
                  onClick={() => {
                    if (codeDestination) {
                      addEventData({
                        label: 'Enviar',
                      });
                    }
                    sendCode()
                  }}
                  disabled={disableButtonOTP}
                >ENVIAR</Button>
              </div>
            </>
          )}

          {step === 3 && (
            <>
              <div className="f-modal-update-data__description">
                <p className='title'>Necesitamos verificar que {italatam ? 'sos vos' : 'eres tu'} </p>

                <p className='description'>
                  {italatam ? 'Ingresá' : 'Ingresa'}  el código de 6 dígitos que hemos enviado a tu{' '}

                  {codeDestination === 'EMAIL' ? 'correo' : 'celular'}.
                </p>
              </div>

              <div className="f-input-container">
                <label className="f-input-indicator">CÓDIGO VERIFICACIÓN</label>
                <div className="f-input-validation-container">
                  <input
                    name="f-verification-code-input"
                    placeholder="Ingresa el código"
                    className={
                      'f-verification-code-input ' +
                      (response === 'success' && ' f-success-validation ') +
                      (response === 'error' && ' f-error-validation')
                    }
                    type="text"
                    maxLength="6"
                    autoComplete="off"
                    value={inputValueOTP || ""}
                    onChange={handleInputValidation}
                  />
                  {response === 'error' && inputValueOTP.length === 6 ? (
                    <span className="icon2-close f-icon f-error-code"></span>
                  ) : null}
                  {response === 'success' && inputValueOTP.length === 6 ? (
                    <span className="icon-check-2 f-icon f-check-code"></span>
                  ) : null}
                </div>
                {response === 'error' && inputValueOTP.length === 6 ? (
                  <label className="f-code-error">Código inválido</label>
                ) : null}
                <label className="f-send-code">
                  ¿No recibiste un código?{' '}
                  <br />
                  <span
                    className={
                      'f-link-send-code ' + (disableResend ? 'disabled' : '')
                    }
                    onClick={() => {
                      addEventData({
                        label: 'Reenviar código',
                      });
                      sendCode(true)
                    }}
                  >
                    Reenviar código
                  </span>
                </label>
                {resentCode && (
                  <p className="f-send-code-re">Tu código ha sido enviado</p>
                )}
              </div>

              <div className="f-modal-update-data__buttons">
                <Button
                  title="ELEGIR OTRO MEDIO"
                  size="f-extraLarge"
                  color="f-blue"
                  onClick={() => {
                    addEventData({ label: 'Volver' });
                    setStep(2)
                  }}
                  havePulsing={false}
                >VOLVER</Button>
                <Button
                  title="ENVIAR"
                  size="f-small"
                  color="f-blue"
                  className='--pink'
                  loading={disableButton}
                  disabled={disableButton}
                  onClick={() => nextToOTP(inputValueOTP)}
                  havePulsing={false}
                >ENVIAR</Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ModalUpdateData
